<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">邀请记录</h4>
			<button type="button" class="form-control btn btn-primary col-1" @click="add()">邀请</button>
          </template>
          <div class="table-responsive text-left">
             <table class="table">
				  <thead><tr><td>邀请时间</td><td>电话</td><td>邀请码</td><td>状态</td><td>邀请者</td></tr></thead>
				  <tbody>
				    <tr v-for="(item,key) in invites" :key="item.id">
					<td >{{ item.createTime }}</td>
					<td >{{ item.tel}}</td>
					<td >{{ item.inviteCode }}</td>
					<td ><span v-if="item.daysDifference>2">失效</span><span v-if="item.daysDifference<=2">有效</span></td>
					<td><span v-if="item.name==null">{{item.loginName}}</span>
					<span v-else>{{item.name}}</span>
					</td>
				    </tr>
				  </tbody>
			  </table>
          </div>
		  
		  <nav aria-label="Page navigation example" style="margin-top:30px;">
		    <ul class="pagination justify-content-center">
		      <li class="page-item" id="previous" :class="{'disabled':params.pageNum==1}">
		        <a class="page-link" href="#" @click="previous()">Previous</a>
		      </li>
		  	<li class='page-item' style="margin-left: 5px;margin-right: 5px;"> page {{params.pageNum}} of {{params.pages}} </li>			  
		      <li class="page-item" id="next" :class="{'disabled':params.pageNum==params.pages}">
		        <a class="page-link" href="#" @click="next()">Next</a>
		      </li>	
		  			  <li class="pageSize" style="margin-left: 5px;"> 每页：
					  <span><a href="#" @click="params.pageSize=10;params.pageNum=1;list();">10</a></span>
					  <span><a href="#" @click="params.pageSize=20;params.pageNum=1;list();">50</a></span>
					  <span><a href="#"  @click="params.pageSize=100;params.pageNum=1;list();">100</a></span></li>
		  			</ul>
		  </nav>
		  
        </card>
      </div>
    </div>
	<Modal :isVisible="showModal" @close="showModal = false">
		<template #header>
		    <div style="color:#000">
			邀请注册
			</div>
		</template>
		  
		<div class="row col-12" style="margin-bottom:10px;">
             <input type="text" class="form-control col-6" placeholder="电话" aria-label="电话" v-model.trim="invitation.tel">			
		</div>

		<div class="row col-12" style="margin-bottom:10px;">
			<input type="text" class="form-control col-4" style="display:inline;" placeholder="关键词" aria-label="客户名称" aria-describedby="basic-addon1" v-model="searchData.keyWord">
			<el-button style="margin-left: 10px;" size="small" class="col-2" type="success" @click="searchCompany()">搜索</el-button>			
		</div>
		<div class="row" style="margin-bottom:10px;">
			<el-select v-model="invitation.companyId" placeholder="请选择公司" class="col-12" clearable>
			  <el-option
				v-for="item in companys"
				clearable
				:key="item.companyId"
				:label="item.name"
				:value="item.companyId">
			  </el-option>
			</el-select>
		</div>
		<div class="row" style="margin-bottom:10px;">			
			<el-select  v-model="invitation.roleId"  clearable placeholder="请选择角色" class="col-12" clearable>
				<el-option
				  v-for="item in roles"
				  :key="item.roleId"
				  :label="item.roleName"
				  :value="item.roleId">
				</el-option>
			</el-select>
			注：给客户提供订单查询的都选择“客户”这个角色。
		</div>
		<template #footer>
		  <span class="text-success" style="padding:15px;">{{msg}}</span>
		  <button @click="invite()" class="btn btn-primary">发出邀请</button>
		</template>
		
	</Modal>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import Modal from "@/pages/Layout/Modal.vue";
import { Message,MessageBox} from "element-ui";
export default {
  components: {
    Card,Modal
  },
  data() {
    return {
      invites: [],
	  params:{
		  pageSize:10,
		  pageNum:1,
		  pages:1,
	  },
	  showModal:false,
	  invitation:{
	  		  tel:"",
	  		  code:"",
			  companyId:"",
			  roleId:""
	  },
	  companys:[],
	  searchData:{
	  		  keyWord:"",
	  		  pageSize:10,
	  		  pageNum:1, 
	  },
	  companyId:"",
	  msg:"",
	  roles:[],
	  roleId:""
    };
  },
  computed: {
    
  },
  created(){
	  this.list()
  },
  methods: {
	  async list(){
	  	let res =await this.$axios.post(this.$serverUrl+"/user/invited",this.params);
		this.invites=res.data.data.list;
		this.params.pageNum=res.data.data.pageNum;
		this.params.pages=res.data.data.pages;
		this.params.pageSize=res.data.data.pageSize;
	  },
	  add(){
		this.showModal=true;
		this.msg="";
		this.invitation.companyId="";
		this.invitation.roleId="";
		this.$axios.post(this.$serverUrl+"/company/search",this.searchData).then(Response=>{
			this.companys=Response.data.data.list
		});	
		this.$axios.get(this.$serverUrl+"/role/list").then(
		  response => {
						this.roleDatas=response
						if(response.data.status=="1"){
							this.roles=response.data.data
						  }
					}
		);
	  },
	  async invite(){
			  if(this.invitation.companyId!=""&&this.invitation.tel!=""){
			  let res =await this.$axios.post(this.$serverUrl+"/user/invite",this.invitation);
			  if(res.data.data!=null){
				this.msg="已邀请"+this.invitation.tel+"注册，验证码"+res.data.data.inviteCode+"已发送，3天有效。"
				this.list();
			  }else{
				this.msg="该号码已经存在未使用邀请码";
			  }
		  }else{
			  Message(
			  {
			   type: "error",
			   message: "电话号码未输入或者未选择公司。",
			   offset:window.screen.height/2-100,
			   showClose: true
			  });
		  }
	  },
	  previous(){
	  		this.params.pageNum=this.params.pageNum-1;
	  		this.list();
	  },
	  next(){
	  		this.params.pageNum=this.params.pageNum+1;
	  		this.list();
	  },	
	  searchCompany(){
		  this.$axios.post(this.$serverUrl+"/company/search",this.searchData).then(Response=>{
		  	//console.log(Response);
		  	this.companys=Response.data.data.list
		  });
	  }
  }
};
</script>
<style></style>
